import { Field, reduxForm } from 'redux-form'
import React, { Component, PropTypes } from 'react'
import InputField from 'client/features/form/components/InputField.jsx'
import REGEXP from 'constant/REGEXP'

const validate = values => {
    const errors = {}
    if (!values.email) errors.email = 'Your email?'
    else if (!REGEXP.validations.email.test(values.email)) errors.email = 'Invalid format.'
    return errors
}

class ResetPasswordForm extends Component {
    render() {
        const { handleSubmit, pristine, submitting, error } = this.props
        return (
            <form onSubmit={ handleSubmit } className='form-horizontal m-t-10'>
                <Field name='email' component={ InputField } type='email' placeholder='Email...'/>
                <div className='form-group text-center m-t-30'>
                    <div className='col-xs-12'>
                        <button className='btn btn-custom btn-bordred btn-block waves-effect waves-light text-uppercase' type='submit' disabled={ pristine || submitting }>Demander</button>
                    </div>
                </div>
                {
                    error ? <p className='error' id='login-error'>{ error }</p> : null
                }
            </form>
        )
    }
}

ResetPasswordForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    pristine: PropTypes.bool.isRequired,
    valid: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired
} 

export default ResetPasswordForm = reduxForm({
    form: 'resetPassword',
    validate
})(ResetPasswordForm)


// WEBPACK FOOTER //
// ./src/client/features/session/components/ResetPasswordForm.jsx